module.exports = __webpack_public_path__ + "img/game_pg.5087dca8.png";